"use client";

import { useAction } from "@rangojs/router/client";
import { logoutAction } from "../actions/logout.js";

export function LogoutLink() {
  const { state } = useAction(logoutAction);

  return (
    <form action={logoutAction} className="inline">
      <button
        type="submit"
        disabled={state === "loading"}
        className="text-slate-600 hover:text-indigo-600 transition-colors font-medium underline underline-offset-2 cursor-pointer bg-transparent border-none p-0"
      >
        {state === "loading" ? "Logging out..." : "Log out"}
      </button>
    </form>
  );
}
